<template>
    <div class="dialogGoodsVisible">
        <el-row style="line-height:40px">
            <el-col :span="2" class="tit">商品名称：</el-col>
            <el-col :span="22">
                <el-input
                    v-model="keyName"
                    placeholder="输入商品名称查询"
                    @keyup.enter.native="specialCharacter"
                    style="width: 220px;float:left"
                ></el-input>
                <el-button
                class="searchBtn"
                @click="search(1)"
                ></el-button>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="2" class="tit">类别：</el-col>
            <el-col :span="22">
                <el-checkbox-group v-model="checktypeList" class="checkBoxcom" @change="search">
                <el-col :span="3">
                    <el-checkbox label="10">库存调整</el-checkbox>
                </el-col>
                <el-col :span="3">
                    <el-checkbox label="8">转成公共套盒</el-checkbox>
                </el-col>
                <el-col :span="3">
                    <el-checkbox label="9">库存盘点</el-checkbox>
                </el-col>
                <el-col :span="3">
                    <el-checkbox label="1">采购入库</el-checkbox>
                </el-col>
                <el-col :span="3">
                    <el-checkbox label="5">退货入库</el-checkbox>
                </el-col>
                <el-col :span="3">
                    <el-checkbox label="4">订单销售</el-checkbox>
                </el-col>
                </el-checkbox-group>
            </el-col>            
        </el-row>
        <el-table
            :data="tableData"
            border
            height="434"
            ref="multipleTable"
            :cell-style="{height:'42px'}"
            @cell-dblclick="changeCheck"
            style="width: 100%" :header-cell-style="{background:'#EFF1F5',height:'47px'}">
            <el-table-column align="center" prop="id" label="选择" width="60">
                <template slot-scope="scope">
                    <el-radio v-model="choosecurRow" :label="scope.row"><span></span></el-radio>
                </template>
            </el-table-column>
            <el-table-column align="center" prop="createTime" label="挂单时间" width='160'>
                <template slot-scope="scope">
                {{scope.row.createTime | filterRow}}
                </template>
            </el-table-column>
            <el-table-column align="center" prop="memberName" label="会员"></el-table-column>
            <el-table-column align="center" prop="memberTelephone" label="手机号"></el-table-column>
            <el-table-column align="center" prop="orderGoodsList" label="项目">
                <template slot-scope="scope">
                    <el-row class="tableGoods">
                    <el-popover trigger="hover" placement="top">
                        {{scope.row.serviceName}}
                        <el-col slot="reference" class="myTitle">
                            <span>{{scope.row.serviceName |　filterRow}}</span>
                        </el-col>
                    </el-popover>
                    </el-row>
                </template>
            </el-table-column>
            <el-table-column align="center" prop="salesmanName" label="销售员"></el-table-column>
            <el-table-column align="center" prop="amountReceivable" label="应付金额">
                <template slot-scope="scope">
                    {{'￥'+Number(scope.row.amountReceivable).toFixed(2)}}
                </template>
            </el-table-column>
        </el-table>
        
        <el-pagination
        v-show="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="margin-top: 20px;text-align:right"
      ></el-pagination>

        <el-row class="dialogbtnOptions">
            <el-button class="darkBtn" @click="closeDialog">取消</el-button>
            <el-button class="redBtn" @click="submit">确定</el-button>
        </el-row>
    </div>
</template>
<script>
let testdata = [];
for(let i =0;i<8;i++){
    testdata.push({
        addType:i,
        serviceName:'测试名称'+i,
        price:123.00,
        oneprice:230,
        forSale:i,
        id:i+1
    })
}
export default {
    data() {
        return {
            tableData:testdata,
            pageSize: 8,
            currentPage: 1,
            total: 10,
            checktypeList:[],
            keyName:'',
            choosecurRow:''
        }
    },
    methods: {
        specialCharacter() {
            this.keyName = this.keyName.replace(
                /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/im,
                ""
            );
            this.search()
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.search();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.search();
        },
        search(val) {
            // if (val == 1) {
            //     this.currentPage = 1;
            // }
            // let res = await saleOrderList({
            //     pageSize: this.pageSize,
            //     currentPage: this.currentPage,
            //     orderType:this.orderType
            // });
            // if (res.data.items.length == 0) {
            //     this.mySearchflag = true;
            // }
            // this.total = res.data.totalNum;
            // this.tableData = res.data.items;
            this.tableData = testdata
        },
        closeDialog(){
            this.$emit('closeDialog',false);
        },
        changeCheck(row) {
            if(row.id){
                this.choosecurRow = '';
                this.choosecurRow = row;
                this.$emit('mySelect',row);
            }
        },
        submit(){
            if(this.choosecurRow){
                this.$emit('mySelect',this.choosecurRow);
            }
        }
    },
}
</script>
<style lang="less">
.dialogGoodsVisible {
  width: 100%;
  overflow: hidden;
  text-align: center;
  .tit {
    color: #666;
    text-align: right;
    padding-right: 20px;
    margin-bottom: 20px;
  }
  .searchBtn {
      width: 47px;
      height: 38px;
      margin-left: 20px;
      background: #f83b56 url(../../assets/images/store/btn_datalist_search.png)
        no-repeat center;
        float: left;
    }
  .el-dialog__title {
    font-weight: bold;
  }
  .el-form-item {
    margin-bottom: 18px;
    .el-form-item__label{
        color: #999
    }
  }
  .el-form-item__content {
    text-align: left;
    .account{
        margin-left: 10px;
    }
  }
  .el-radio__label{
      padding: 0;
  }
  .el-input__inner {
    height: 35px;
    line-height: 35px;
    border-radius: 18px;
  }
  .el-button.redBtn {
    background: #F83B56;
    color: #fff;
  }
  .el-button.darkBtn {
    background: #3b404f;
    color: #fff;
  }
  .dialogbtnOptions {
    margin-top: 26px;
    text-align: center;
    .el-button {
      min-width: 105px;
      height: 38px;
      border:none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/businessManagementCenter/goodsList.vue